import { Field, useFormikContext } from 'formik';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import ModuleImage from '../../images/Modules_and_IO.svg';
import { ListQuery } from '../../models/ListQuery';
import { getDeviceProfileNames } from '../../services/hardwarePresetService';
import { IAppState } from '../../store/types';
import { appendFilter } from '../../utilities/filters';
import { validateItemName } from '../../utilities/Validation';
import EntityHierarchy from '../entityHierarchy/entityHierarchy';
import Label from '../label/label';
import PaginatedSearchableSelectField from '../selection-field/paginated-searchable-select-field';
import Togglebox from '../togglebox/togglebox';
import { PRESET_TYPES } from '../../constants/preset-constants';

const IOModuleCard: FC = () => {
    const { errors, values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();
    const siteId = useSelector((state: IAppState) => state.site.site.value)

    return <div className="w-full p-2 inline-flex justify-start items-center bg-white">
        <span>
            <img className='hardware-image' src={ModuleImage} alt="module" />
        </span><div className="flex flex-col py-4 px-4 card-details ">
            {values.id ?
                <EntityHierarchy title={values.name} tree={{ label: values.site, node: { label: values.controller, node: { label: values.fixedAddress } } }} />
                : null}
        </div>
        <div className="flex flex-col py-4 px-8">
            <div className="mb-1">
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="name"
                        required
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.name)}:</Label>
                    {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                </div>
                <Field
                    type="text"
                    name="name"
                    autoFocus
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                    validate={(value) => validateItemName(value, translate)} />
            </div>

            <div className="mb-1">
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="fixedAddress"
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.fixedAddress)}:</Label>
                </div>
                <Field
                    name="fixedAddress"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>

            <div className="flex flex-row justify-between">
                <Label
                    htmlFor="logicalAddress"
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.logicalAddress)}:</Label>
            </div>
            <Field
                name="logicalAddress"
                disabled={true}
                className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
        </div>
        <div className="flex flex-col py-4 px-8">
            <div className="mb-1">
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="presetId"
                        required
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.preset)}:</Label>
                </div>
                <PaginatedSearchableSelectField
                    name={translate.byKey(TranslationKeys.preset)}
                    key={"presetId"}
                    accessor='presetId'
                    dataMethod={(listParameters?: ListQuery) => getDeviceProfileNames(PRESET_TYPES.IOMODULE, { ...listParameters, filters: appendFilter(values.siteId ?? siteId, 'Site id', 'site.id', listParameters?.filters ?? []) })}
                    searchAccessor={'trnName'}
                    onSelect={(event, item) => {
                        setFieldValue('preset', item?.label);
                        setFieldValue('presetId', item?.value);
                    }}
                    selectedItemLabel={values.preset} 
                    disabled={values.isUsedByLift}/>
            </div>
            <div className="mb-1">
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="ipAddress"
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.ipAddress)}:</Label>
                </div>
                <Field
                    name="ipAddress"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>
            <div className="flex flex-row justify-between">
                <Label
                    htmlFor="enabled"
                    className="text-xs text-gray-600 mt-1 my-1">{translate.byKey(TranslationKeys.enabled)}:</Label>
            </div>
            <div className="my-0">
                <Togglebox name="enabled" label="" />
            </div>
        </div>
    </div>
}

export default IOModuleCard;